import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#051e34',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        buttonAction: '#006CA1'
      },
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      dropdown: 'fa-light fa-chevron-down fa-xs',
    },
  }
})
export default vuetify;
